import React from "react";
import { Link } from "react-router-dom";

export const Cta = ({ title, text, buttonLabel = "Request a Quote", to = "/contact" }) => (
  <div className="cta-band">
    <div className="container text-center">
      <h2>{title}</h2>
      <p>{text}</p>
      <Link to={to} className="btn btn-custom btn-lg">
        {buttonLabel}
      </Link>
    </div>
  </div>
);
